import {gql} from "@apollo/client";

export default gql`
mutation RemoveTimeBasePremium($removeTimeBasePremiumId: Int!) {
    removeTimeBasePremium(id: $removeTimeBasePremiumId)
}
`;